import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { MenuItem } from '@material-ui/core';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { Select as SENDER_SELECT } from 'Components/Api/NovityDMTAPI';
import { Select as SELECT_BANK } from 'Components/Api/DMTPipeMasterAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    MONEY_TRANSFER_CODE
} from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import { Last10PPIReport } from 'Pages/InnerPages/Report/Last10PPIReport';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import usePosition from 'Components/Posistion';
import HOCLoader from 'Components/Loader/HOCLoader';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import { useLocation } from 'react-router-dom';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = () => {
    const formRef = useRef();
    const classes = commonStyle();
    const location = useLocation();
    const history = useHistory();
    const [senderNo, setSenderNo] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [Bank, setBank] = useState([]);
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);
    const Mobile = location?.state?.Mobile;
    const BankPipe = location?.state?.BankPipe;
    const ActiveDMTName = location?.state?.DMTName;
    const { latitude, longitude } = usePosition();
    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        Consumed: '',
        BankPipe: BankPipe || '',
        isAddBeneficiary: false,
        DMTName: ActiveDMTName,
        Latitude: latitude,
        Longitude: longitude
    });
    useEffect(() => {
        GetBankTypeList();
        if (BankPipe) {
            setFormObject((prev) => ({
                ...prev,
                BankPipe: BankPipe
            }));
        }
        select();
        setLoading(false);
    }, [BankPipe]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (formRef === undefined) return;

            if (!formRef.current) return;

            if (formRef.current.values === undefined) return;

            if (formRef.current.values.Mobile === undefined) return;

            if (formRef.current.values.Mobile.length !== 10) return;

            formRef.current.handleSubmit();
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const GetBankTypeList = async () => {
        var request = {
            ActiveDMTName: ActiveDMTName
        };
        var json = JSON.stringify(request);
        const response = await SELECT_BANK(json);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setBank(data);

        if (!formObject.Pipe) {
            setFormObject((prevState) => ({
                ...prevState,
                Pipe: data.length > 0 ? data[0].BankName : ''
            }));
        }
    };

    const BankList = Bank.map((item) => (
        <MenuItem key={item.DMTPipeMasterID} value={item.Value}>
            {' '}
            {item.BankName}
        </MenuItem>
    ));

    const select = async () => {
        let primaryID = Mobile;
        if (primaryID === undefined) return;
        if (primaryID === null) return;
        if (primaryID === 'DMT') return;

        if (primaryID.length !== 10) return;

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            BankPipe: BankPipe || formObject.BankPipe,
            Name: '',
            SenderID: '',
            RemainingLimit: ''
        });
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            BankPipe: values.BankPipe,
            Name: '',
            SenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });
        setServiceCode('');
        setSenderNo('');
        values.DMTName = ActiveDMTName;
        values.Latitude = latitude;
        values.Longitude = longitude;
        var requestObj = JSON.stringify(values);
        setLoading(true);
        setIsError(false);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                BankPipe: values.BankPipe,
                SenderID: values.SenderID,
                SenderName: values.Name,
                DMTName: ActiveDMTName
            };
            history.push('/NTDMT_BeneficiaryAdd', param);
            return;
        } 
        var response = await SENDER_SELECT(requestObj); 
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        var param_2 = {
            Mobile: values.Mobile,
            DMTName: ActiveDMTName,
            BankPipe: values.BankPipe
        }; 
        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            if (response.data === 'Customer Number does not exist') {
                setResponseMessage(response.data);
                history.push('/NTDMT_SenderAdd', param_2);
                return;
            }
            if (
                response.data ===
                'This customer is not registered for DMT service.'
            ) {
                setResponseMessage(response.data);
                history.push('/NTDMT_AirtelBankSenderAdd', param_2);
                return;
            }
            if (response.data === 'This Sender Id is not Registered with us.') {
                setResponseMessage(response.data);
                history.push('/NTDMT_NSDLBank3SenderAdharVerifyEKYC', param_2);
                return;
            }
            if (response.data === 'Customer EKYC Not Done or Do EKYC again') {
                setResponseMessage(response.data);
                history.push('/NTDMT_SenderEKYC', param_2);
                return;
            }

            if (response.data === 'Sender not verified') {
                setResponseMessage(response.data);
                history.push('/NTDMT_SenderVerify', param_2);
                return;
            }


            return;
        }

        var data = JSON.parse(response.data);

        setAddBeneficiary('inline');

        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            SenderID: data.SenderID,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimit,
            BankPipe: values.BankPipe,
            isAddBeneficiary: false
        });

        setSenderNo(data.Mobile);
        setLoading(false);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MaterialSelect
                                                label="BankPipe"
                                                name="BankPipe"
                                                title="BankPipe"
                                                value={formObject.BankPipe}
                                                onChange={(e) => {
                                                    const selectedBank = Bank.find((bank) => bank.Value === e.target.value);
                                                    setFormObject({
                                                        ...formObject,
                                                        BankPipe: selectedBank ? selectedBank.Value : '',
                                                        Pipe: selectedBank ? selectedBank.BankName : ''
                                                    });
                                                }}
                                                autoFocus
                                            >
                                                {Bank.map((bank) => (
                                                    <MenuItem key={bank.Value} value={bank.Value}>
                                                        {bank.BankName}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                typed_length={1}
                                                placeholder="Mobile"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MaterialTextField
                                                label="Name"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Name"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <MaterialTextField
                                                label="Remaining Limit"
                                                name="RemainingLimit"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Remaining Limit"
                                            />
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MaterialTextField
                                                label="Consumed"
                                                name="Consumed"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Consumed"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <BeneficiaryList
                senderNo={senderNo}
                ActiveDMTName={ActiveDMTName}
                Lat={latitude}
                Long={longitude}
                senderName={formObject.Name}
                BankPipe={formObject.BankPipe}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            <Last10PPIReport
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
        </CustomContainer>
    );
};
